export const buildPredictiveChartData = (predictiveData) => ({
    labels: predictiveData.map((item) => item.failureDate),
    datasets: [
        {
            label: 'Historical failures',
            data: predictiveData.map((item) => Number(item.failureCount) || 0),
            borderColor: '#d64545',
            backgroundColor: 'rgba(214, 69, 69, 0.16)',
            fill: true,
            tension: 0.3,
        },
    ],
});

export const predictiveChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { position: 'bottom' },
        tooltip: {
            callbacks: {
                label: (context) => `Failures: ${context.raw}`,
            },
        },
    },
    scales: {
        x: {
            title: { display: true, text: 'Date' },
        },
        y: {
            beginAtZero: true,
            title: { display: true, text: 'Failure count' },
        },
    },
};

export const getPredictiveMetrics = (predictiveData, prediction) => {
    const totalFailures = predictiveData.reduce((sum, item) => sum + (Number(item.failureCount) || 0), 0);

    return [
        { label: 'Historical points', value: predictiveData.length, tone: 'neutral' },
        { label: 'Historical failures', value: totalFailures, tone: 'fail' },
        { label: 'Estimated failures', value: prediction?.estimatedFailures ?? '-', tone: 'fail' },
        { label: 'Prediction date', value: prediction?.predictionDate ?? '-', tone: 'neutral' },
    ];
};
